module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.StatelessDropdownMenu = void 0;
    var _toConsumableArray2 = __webpack_require__(2), _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2), _getPrototypeOf = __webpack_require__(3), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(4), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(5), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(6), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(7), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(8), _react2 = _interopRequireDefault(_react), _StatelessMenu = __webpack_require__(9), _StatelessMenu2 = _interopRequireDefault(_StatelessMenu), DropdownMenu = function(_PureComponent) {
        function DropdownMenu() {
            var _ref, _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, DropdownMenu);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropdownMenu.__proto__ || (0, 
            _getPrototypeOf2.default)(DropdownMenu)).call.apply(_ref, [ this ].concat(args))), 
            _this.state = {
                isOpen: _this.props.defaultOpen,
                items: [].concat((0, _toConsumableArray3.default)(_this.props.items))
            }, _this.findActivatedGroup = function(item) {
                return _this.state.items.filter(function(group) {
                    return group.items.indexOf(item) > -1;
                })[0];
            }, _this.handleItemActivation = function(attrs) {
                var activatedItem = attrs.item, activatedGroup = _this.findActivatedGroup(activatedItem), items = [].concat((0, 
                _toConsumableArray3.default)(_this.state.items));
                switch (activatedItem.type) {
                  case "checkbox":
                    activatedItem.isChecked = !activatedItem.isChecked, _this.props.onItemActivated({
                        item: activatedItem
                    }), _this.setState({
                        items: items
                    });
                    break;

                  case "radio":
                    activatedGroup.items.forEach(function(i) {
                        i === activatedItem ? i.isChecked = !0 : i.isChecked = !1;
                    }), _this.props.onItemActivated({
                        item: activatedItem
                    }), _this.setState({
                        items: items
                    });
                    break;

                  case "link":
                  default:
                    _this.props.onItemActivated({
                        item: activatedItem
                    }), _this.close();
                }
            }, _this.handleOpenChange = function(attrs) {
                _this.setState({
                    isOpen: attrs.isOpen
                }), _this.props.onOpenChange(attrs);
            }, _this.close = function() {
                _this.setState({
                    isOpen: !1
                }), _this.props.onOpenChange({
                    isOpen: !1
                });
            }, _this.render = function() {
                var _this2 = _this, props = _this2.props, state = _this2.state;
                return _react2.default.createElement(_StatelessMenu2.default, {
                    position: props.position,
                    appearance: props.appearance,
                    isOpen: state.isOpen,
                    onItemActivated: _this.handleItemActivation,
                    onOpenChange: _this.handleOpenChange,
                    isTriggerNotTabbable: props.isTriggerNotTabbable,
                    triggerType: props.triggerType,
                    shouldFlip: props.shouldFlip,
                    items: state.items
                }, props.children);
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(DropdownMenu, _PureComponent), (0, _createClass3.default)(DropdownMenu, [ {
            key: "componentWillReceiveProps",
            value: function(nextProps) {
                nextProps.items !== this.state.items && this.setState({
                    items: [].concat((0, _toConsumableArray3.default)(nextProps.items))
                });
            }
        } ]), DropdownMenu;
    }(_react.PureComponent);
    DropdownMenu.propTypes = {
        appearance: _react.PropTypes.oneOf([ "default", "tall" ]),
        children: _react.PropTypes.node,
        defaultOpen: _react.PropTypes.bool,
        isTriggerNotTabbable: _react.PropTypes.bool,
        items: _react.PropTypes.array.isRequired,
        // eslint-disable-line react/forbid-prop-types
        onItemActivated: _react.PropTypes.func,
        onOpenChange: _react.PropTypes.func,
        position: _react.PropTypes.string,
        triggerType: _react.PropTypes.oneOf([ "default", "button" ]),
        shouldFlip: _react.PropTypes.bool
    }, DropdownMenu.defaultProps = {
        appearance: "default",
        defaultOpen: !1,
        isTriggerNotTabbable: !1,
        items: [],
        onItemActivated: function() {},
        onOpenChange: function() {},
        position: "bottom left",
        triggerType: "default",
        shouldFlip: !0
    }, exports.default = DropdownMenu, exports.StatelessDropdownMenu = _StatelessMenu2.default;
}, /* 2 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/toConsumableArray");
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/get-prototype-of");
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/createClass");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 9 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(10), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(3), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(4), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(6), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(7), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(8), _react2 = _interopRequireDefault(_react), _akDroplist = __webpack_require__(11), _akDroplist2 = _interopRequireDefault(_akDroplist), _akDroplistItem = __webpack_require__(12), _akDroplistItem2 = _interopRequireDefault(_akDroplistItem), _akDroplistGroup = __webpack_require__(13), _akDroplistGroup2 = _interopRequireDefault(_akDroplistGroup), _akButton = __webpack_require__(14), _akButton2 = _interopRequireDefault(_akButton), _expand = __webpack_require__(15), _expand2 = _interopRequireDefault(_expand), _uid = __webpack_require__(16), _uid2 = _interopRequireDefault(_uid), Icon = _react2.default.createElement(_expand2.default, {
        label: ""
    }), StatelessDropdownMenu = function(_PureComponent) {
        function StatelessDropdownMenu() {
            var _ref, _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, StatelessDropdownMenu);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, (_ref = StatelessDropdownMenu.__proto__ || (0, 
            _getPrototypeOf2.default)(StatelessDropdownMenu)).call.apply(_ref, [ this ].concat(args))), 
            _this.state = {
                id: (0, _uid2.default)()
            }, _this.renderItems = function(items) {
                return items.map(function(item, itemIndex) {
                    return _react2.default.createElement(_akDroplistItem2.default, (0, _extends3.default)({}, item, {
                        key: itemIndex,
                        onActivate: function() {
                            _this.props.onItemActivated({
                                item: item
                            });
                        }
                    }), item.content);
                });
            }, _this.renderGroups = function(groups) {
                return groups.map(function(group, groupIndex) {
                    return _react2.default.createElement(_akDroplistGroup2.default, {
                        heading: group.heading,
                        key: groupIndex
                    }, _this.renderItems(group.items));
                });
            }, _this.render = function() {
                var _this2 = _this, props = _this2.props, state = _this2.state;
                return _react2.default.createElement(_akDroplist2.default, {
                    position: props.position,
                    appearance: props.appearance,
                    isOpen: props.isOpen,
                    onOpenChange: props.onOpenChange,
                    isTriggerNotTabbable: "button" === props.triggerType || props.isTriggerNotTabbable,
                    shouldFlip: props.shouldFlip,
                    trigger: "button" === props.triggerType ? _react2.default.createElement(_akButton2.default, {
                        isSelected: props.isOpen,
                        iconAfter: Icon,
                        ariaHaspopup: !0,
                        ariaExpanded: props.isOpen,
                        ariaControls: state.id
                    }, props.children) : props.children
                }, _react2.default.createElement("div", {
                    id: state.id,
                    role: "menu"
                }, _this.renderGroups(props.items)));
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(StatelessDropdownMenu, _PureComponent), StatelessDropdownMenu;
    }(_react.PureComponent);
    StatelessDropdownMenu.propTypes = {
        appearance: _react.PropTypes.oneOf([ "default", "tall" ]),
        children: _react.PropTypes.node,
        isOpen: _react.PropTypes.bool,
        isTriggerNotTabbable: _react.PropTypes.bool,
        items: _react.PropTypes.array.isRequired,
        // eslint-disable-line react/forbid-prop-types
        onItemActivated: _react.PropTypes.func,
        onOpenChange: _react.PropTypes.func,
        position: _react.PropTypes.string,
        triggerType: _react.PropTypes.oneOf([ "default", "button" ]),
        shouldFlip: _react.PropTypes.bool
    }, StatelessDropdownMenu.defaultProps = {
        appearance: "default",
        isOpen: !1,
        isTriggerNotTabbable: !1,
        items: [],
        onItemActivated: function() {},
        onOpenChange: function() {},
        position: "bottom left",
        triggerType: "default",
        shouldFlip: !0
    }, exports.default = StatelessDropdownMenu;
}, /* 10 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/extends");
}, /* 11 */
/***/
function(module, exports) {
    module.exports = require("ak-droplist");
}, /* 12 */
/***/
function(module, exports) {
    module.exports = require("ak-droplist-item");
}, /* 13 */
/***/
function(module, exports) {
    module.exports = require("ak-droplist-group");
}, /* 14 */
/***/
function(module, exports) {
    module.exports = require("ak-button");
}, /* 15 */
/***/
function(module, exports) {
    module.exports = require("ak-icon/glyph/expand");
}, /* 16 */
/***/
function(module, exports) {
    module.exports = require("uid");
} ]);


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/ak-dropdown-menu/dist/bundle-cjs.js
// module id = 329
// module chunks = 0